import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Lọc mạng nội bộ
export function locMangNoiBo(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/mang/', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy mạng nội bộ
export function layMangNoiBo(id: number) {
  try {
    return axiosApi.get('/cham-cong/mang/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo mạng nội bộ
export function taoMangNoiBo(params: any) {
  try {
    return axiosApi.post('/cham-cong/mang/', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật mạng nội bộ
export function capNhatMangNoiBo(id: number, params: any) {
  try {
    return axiosApi.put('/cham-cong/mang/' + id, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa mạng nội bộ
export function xoaMangNoiBo(id: number) {
  try {
    return axiosApi.delete('/cham-cong/mang/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
